import React, { useState, useEffect } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { motion } from 'framer-motion';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import AppBar from '../navigation/AppBar';
import Sidebar from '../scenes/user/hospital/dashboard_sections/sidebar';
import { useHospitalAuth } from '../hooks/useHospitalAuth';
import { TOASTIFY_NEWEST_ON_TOP } from '../utils/config/config';
import PageThemeProvider from '../themes/user/hospital/theme';

const DashboardLayout = () => {
	const { patientData } = useHospitalAuth(true, true);

	// Separate desktop and mobile sidebar states
	const [isSidebarExpanded, setIsSidebarExpanded] = useState(true); // For desktop (icons + text vs icons only)
	const [isSidebarVisible, setIsSidebarVisible] = useState(false); // For mobile (visible vs hidden)
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	// const [notificationCount, setNotificationCount] = useState(0);

	// Handle resize events
	useEffect(() => {
		const handleResize = () => {
			const mobile = window.innerWidth < 768;
			setIsMobile(mobile);

			// When switching between mobile and desktop modes
			if (mobile) {
				// On mobile, hide sidebar by default
				setIsSidebarVisible(false);
			} else {
				// On desktop, always show sidebar (expanded or collapsed)
				setIsSidebarVisible(true);
			}
		};

		window.addEventListener('resize', handleResize);
		handleResize(); // Initial check

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// Toggle sidebar functions
	const toggleSidebarExpansion = () => {
		setIsSidebarExpanded(!isSidebarExpanded);
	};

	const toggleSidebarVisibility = () => {
		setIsSidebarVisible(!isSidebarVisible);
	};

	return (
		<PageThemeProvider>
			<div className={css(styles.layoutContainer)}>
				{/* <AppBar
          isMobile={isMobile}
          isSidebarVisible={isSidebarVisible}
          toggleSidebarVisibility={toggleSidebarVisibility}
          notificationCount={notificationCount}
        /> */}

				<Sidebar
					patientData={patientData}
					isSidebarExpanded={isSidebarExpanded}
					isSidebarVisible={isMobile ? isSidebarVisible : true} // Force visible on desktop
					isMobile={isMobile}
					toggleSidebarExpansion={toggleSidebarExpansion}
					setIsSidebarVisible={setIsSidebarVisible}
				/>

				<motion.main
					className={css(
						styles.mainContent,
						isMobile
							? isSidebarVisible
								? styles.mainContentMobileSidebarOpen
								: styles.mainContentMobile
							: isSidebarExpanded
								? styles.mainContentExpandedSidebar
								: styles.mainContentCollapsedSidebar,
					)}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 0.5 }}
				>
					<Outlet />
				</motion.main>
				<ToastContainer newestOnTop={TOASTIFY_NEWEST_ON_TOP} />
			</div>
		</PageThemeProvider>
	);
};

const styles = StyleSheet.create({
	layoutContainer: {
		display: 'flex',
		flexDirection: 'column', // Change from column to row
		minHeight: '100vh',
		backgroundColor: '#f6f7f9',
		overflow: 'auto',
	},
	mainContent: {
		flexGrow: 1,
		padding: '1.5rem',
		transition: 'margin-left 0.3s',
	},
	mainContentMobile: {
		marginLeft: 0,
		width: '100%',
	},
	mainContentMobileSidebarOpen: {
		marginLeft: 0,
		width: '100%',
	},
	mainContentExpandedSidebar: {
		marginLeft: '250px',
	},
	mainContentCollapsedSidebar: {
		marginLeft: '75px',
	},
});

export default DashboardLayout;
